export default __webpack_public_path__ + "static/media/close12.981e3d54.svg";